import './dashboard_review_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.ReviewQueueDashboardResultView extends Monitoring.Views.DashboardReviewView
  defaultSearchMethod: 'queue_search'

  initialize: (@options = {}) ->
    super @options
    @cameFromModerationDashboard = true

  delayUrl: ->
    '/monitoring/dashboard/queue_delay.json/'

  moderateAction: ->
    'queue_moderate'

  doneAction: ->
    'queue_next_batch'

  moderateContents: (socialContentViews) ->
    super(socialContentViews)
    idsToEscalate = _.map(_.filter(@socialContentViews, (view) -> view.shouldBeEscalated()), (view) -> view.model.get('id'))
    if idsToEscalate.length > 0
      $.post('/monitoring/dashboard/queue_escalate', { uuid: @searchQuery.get('uuid'), ids: idsToEscalate })

  done: =>
    @trigger('onDone')
    super

  _timeOut: =>
    super
    @redirectToModerationDashboard()
